import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { BcAccountClientService } from '../../../service/bc-account-client.service';

export interface ExtensionReason {
	clientID: string;
}

@Component({
	selector: 'app-bc-e-committee-reason',
	templateUrl: './bc-e-committee-reason.component.html',
	styleUrls: ['./bc-e-committee-reason.component.scss'],
	providers: [BcAccountClientService]
})
export class BcEreasonSelectorComponent extends DialogComponent<ExtensionReason, any> implements ExtensionReason, OnInit {

	clientID: string;
	private ctcList;
	private ctc;
	private commentary;

	constructor(dialogService: DialogService,
		private bcAccountClientService: BcAccountClientService) {
		super(dialogService);
	}

	ngOnInit() {
		this.getCTCByAccountClient();
		this.commentary = 'Segue proposta para sua avaliação.';
	}

	getCTCByAccountClient() {
		this.bcAccountClientService.getCtcByAccountClient(this.clientID).subscribe(result => {
			if (result.Success) {
				this.ctcList = result.Result;
				if (this.ctcList.length === 1) {
					this.ctc = this.ctcList[0].CodigoSap;
				}
			} else {

			}
		}, error => {
			console.log(error);
		});
	}

	confirm() {
    	// getCtcByAccountClient(id),
    	// we set dialog result as true on click on confirm button, 
    	// then we can get dialog result from caller code 
		this.result = {
			selectedCTC: this.ctc, 
			commentary: this.commentary
		};
	  	this.close();
	}
}


// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-extension-proposal/bc-e-committee/bc-e-committee-reason/bc-e-committee-reason.component.ts